import cn from 'classnames';
import { i18nPath } from 'config/i18nNs';
import useTabs from 'hooks/useTabs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { getI18nItems } from 'utils/format';
import { fromExcom, projectId } from 'utils/urlQueries';
import { getPathInfo, isExcom } from 'utils/versionUtils';
import styles from './navbar.module.scss';

export interface NavProps {
  toggleActive: () => void;
  isEmployees?: boolean;
  navigationId?: string | null;
  testId?: string | null;
}

const NavBar: React.FC<NavProps> = ({
  toggleActive,
  isEmployees = false,
  navigationId = 'mainNavigation',
  testId = 'navigation'
}) => {
  const { t } = useTranslation();
  const { showTabs } = useTabs();
  const { locPath, polVersion } = getPathInfo();
  const navItems = getI18nItems(t, `${i18nPath.master}.navigation`);
  const homepageURL =
    isExcom(projectId) || fromExcom
      ? '/employees/home-excom'
      : '/employees/home';

  return (
    <div
      className={styles.root}
      id={navigationId || undefined}
      data-testid={testId || undefined}
    >
      <nav>
        <ul className={cn(isEmployees && styles.uppercase)}>
          {isEmployees && polVersion === 'employees' && (
            <li onClick={toggleActive}>
              <a href={homepageURL} onClick={() => showTabs(false)}>
                {t(`${i18nPath.dictionary}.homepage`)}
              </a>
            </li>
          )}

          {navItems.map((item, index: number) => {
            const { alias } = item;
            const page = alias !== '/' ? alias : '';

            return (
              <li key={index} onClick={toggleActive}>
                <NavLink
                  to={`/${locPath}/${page}?id=${projectId}`}
                  activeClassName={styles.active}
                  onClick={() => showTabs(false)}
                  exact
                >
                  {item.label}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default NavBar;
